import { postRequest } from './requestUtils';
import { analyticsTrack } from './analyticsUtils';
export var sendConfirmationEmail = function sendConfirmationEmail(event, url, email, csrfToken, location, replacementText) {
  var target = event.target;
  postRequest(url, {
    email: email
  }, csrfToken).then(function () {
    analyticsTrack('Resend confirmation email', {
      location: location
    });
    target.replaceWith(replacementText || 'Sent!');
  });
};
export default sendConfirmationEmail; // Default export